import { StyleSheet } from '@react-pdf/renderer'

export const ActivityLogPDFStyle = StyleSheet.create({
  page: {
    paddingBottom: '3cm',
    paddingLeft: '2cm',
    paddingRight: '2cm',
    paddingTop: '1.5cm',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '1.5cm',
  },
  headerLogo: {
    height: '60px',
    width: '60px',
    objectFit: 'contain',
  },
  headerTitle: {
    fontSize: '20px',
  },
  footer: {
    position: 'absolute',
    bottom: '1.25cm',
    left: '2.5cm',
    right: '2.5cm',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    fontSize: '7px',
  },
})
